// Gains obtenus sans compte. Le serveur les met de côté sous forme de jetons
// signés : le navigateur ne fait que les transporter, il ne peut ni les lire ni
// en fabriquer. Ils sont encaissés à la création du compte.
const KEY = "popuquiz_pending_rewards";

function read() {
  try {
    const raw = JSON.parse(localStorage.getItem(KEY));
    return Array.isArray(raw) ? raw : [];
  } catch (_) { return []; }
}

function write(list) {
  try { localStorage.setItem(KEY, JSON.stringify(list.slice(-50))); } catch (_) {}
}

// Mémorise le gain d'une partie jouée en anonyme
export function addPendingReward(claimToken, coins, junk) {
  if (!claimToken) return;
  const list = read();
  if (list.some(r => r.token === claimToken)) return;
  list.push({ token: claimToken, coins: coins || 0, junk: junk || 0 });
  write(list);
}

// Total en attente, pour l'afficher avant l'inscription
export function pendingTotals() {
  return read().reduce(
    (acc, r) => ({ coins: acc.coins + (r.coins || 0), junk: acc.junk + (r.junk || 0) }),
    { coins: 0, junk: 0 }
  );
}

export function pendingTokens() {
  return read().map(r => r.token);
}

export function clearPendingRewards() {
  try { localStorage.removeItem(KEY); } catch (_) {}
}
